module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "settings"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Account"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Update your avatar, add your title and adjust notification settings'),
      expression: "'Update your avatar, add your title and adjust notification settings'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })])]), _vm._v(" "), (_vm.person) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-3 text-center"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.person.avatar
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "btn btn-success avatar-button",
    attrs: {
      "for": "avatar"
    }
  }, [(_vm.localStorage.roles.includes('Mentor')) ? _c('span', [_vm._v("\n                        Change Profile Picture\n                    ")]) : _c('span', [_vm._v("\n                        Change Avatar\n                    ")])]), _vm._v(" "), _c('input', {
    ref: "avatar",
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "name": "avatar",
      "id": "avatar"
    },
    on: {
      "change": _vm.setAvatar
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-9"
  }, [_c('h3', [_vm._v("General Information")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Name")]), _c('td', [_vm._v(_vm._s(_vm.person.firstName) + " " + _vm._s(_vm.person.lastName))])]), _vm._v(" "), (!_vm.roles.includes('Recruiter') && !_vm.roles.includes('GlobalMentor')) ? _c('tr', [_c('td', [_vm._v("Title")]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.title),
      expression: "person.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.person.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.person.title = $event.target.value
      }
    }
  })])]) : _vm._e()])]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("ID Number")]), _c('td', [_vm._v(_vm._s(_vm.person.populiId))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Address")]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.address),
      expression: "person.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.person.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.person.address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("City")]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.city),
      expression: "person.city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.person.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.person.city = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("State / Province")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.province),
      expression: "person.province"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.person.province = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.provinces), function(province) {
    return _c('option', {
      domProps: {
        "value": province.name
      }
    }, [_vm._v(_vm._s(province.name))])
  }))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Postal / Zip Code")]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.postal),
      expression: "person.postal"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.person.postal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.person.postal = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Country")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.country),
      expression: "person.country"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.person.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.countries), function(country) {
    return _c('option', {
      domProps: {
        "value": country.displayName
      }
    }, [_vm._v(_vm._s(country.displayName))])
  }))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Phone")]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.phone),
      expression: "person.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.person.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.person.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), (!_vm.roles.includes('Recruiter') && !_vm.roles.includes('GlobalMentor')) ? _c('tr', [_c('td', [_vm._v("Website")]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.website),
      expression: "person.website"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "url"
    },
    domProps: {
      "value": (_vm.person.website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.person.website = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.localStorage.roles.includes('Student') || _vm.localStorage.roles.includes('CampusStudent')) ? _c('tr', [_c('td', [_vm._v("Date Of Birth")]), _vm._v(" "), (_vm.person.dateOfBirth) ? _c('td', [_vm._v(_vm._s(_vm.person.dateOfBirth.split('T')[0]))]) : _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.dateOfBirth),
      expression: "person.dateOfBirth"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.person.dateOfBirth)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.person.dateOfBirth = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.person.socialLinks), function(value, propertyName) {
    return (_vm.person.socialLinks && _vm.person.socialLinks.toString() !== '{}') ? _c('tr', [_c('td', [_vm._v(_vm._s(propertyName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(value) + " "), _c('button', {
      staticClass: "remove-link",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteLink(propertyName)
        }
      }
    }, [_vm._v("x")])])]) : _vm._e()
  }), _vm._v(" "), _c('tr', [_c('td', [_c('label', [_vm._v("Add Social Link")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.socialLink.platform),
      expression: "socialLink.platform"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.socialLink.platform = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.platforms), function(platform) {
    return _c('option', {
      domProps: {
        "value": platform
      }
    }, [_vm._v(_vm._s(platform))])
  }))]), _vm._v(" "), _c('td', {
    staticClass: "social-link"
  }, [_c('label', [_vm._v("URL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.socialLink.url),
      expression: "socialLink.url"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.socialLink.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.socialLink.url = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.updateSocialLinks()
      }
    }
  }, [_vm._v("Add")])])])], 2)]), _vm._v(" "), (_vm.roles.includes('Recruiter')) ? _c('h3', [_vm._v("\n                    Recruiter Information\n                ")]) : _vm._e(), _vm._v(" "), (_vm.roles.includes('Recruiter')) ? _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("\n                                Job Title\n                            ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.jobTitle),
      expression: "person.jobTitle"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.person.jobTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.person.jobTitle = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                                Company\n                            ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.company),
      expression: "person.company"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.person.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.person.company = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                                Website\n                            ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.website),
      expression: "person.website"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.person.website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.person.website = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                                Job Description\n                            ")]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.jobDescription),
      expression: "person.jobDescription"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.person.jobDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.person.jobDescription = $event.target.value
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateInfo()
      }
    }
  }, [_vm._v("Update")])])]), _vm._v(" "), (_vm.roles.includes('Mentor') || _vm.roles.includes('GlobalMentor')) ? _c('mentor-profile-editor') : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    staticClass: "change-password"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword.currentPassword),
      expression: "newPassword.currentPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "current_password",
      "placeholder": "Current Password"
    },
    domProps: {
      "value": (_vm.newPassword.currentPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword.currentPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword.newPassword),
      expression: "newPassword.newPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "new_password",
      "placeholder": "New Password"
    },
    domProps: {
      "value": (_vm.newPassword.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword.newPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword.confirmPassword),
      expression: "newPassword.confirmPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "confirm_new_password",
      "placeholder": "Confirm New Password"
    },
    domProps: {
      "value": (_vm.newPassword.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword.confirmPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changePassword()
      }
    }
  }, [_vm._v("Change Password")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n            Documents\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, _vm._l((_vm.documents), function(document) {
    return _c('div', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.downloadSlip(document)
        }
      }
    }, [_vm._v(_vm._s(document.type))])])
  }))]), _vm._v(" "), (_vm.roles !== ['Recruiter']) ? _c('div', {
    staticClass: "panel"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-body notification-settings-wrapper"
  }, [_c('ul', {
    staticClass: "notification-settings clearfix"
  }, [_c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                        Desktop Notifications\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('toggle-button', {
    on: {
      "change": _vm.setDesktopNotifications
    },
    model: {
      value: (_vm.showDesktopNotifications),
      callback: function($$v) {
        _vm.showDesktopNotifications = $$v
      },
      expression: "showDesktopNotifications"
    }
  })], 1)]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                        Email Notifications\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('toggle-button', {
    on: {
      "change": _vm.setEmailNotifications
    },
    model: {
      value: (_vm.settings.getEmailNotifications),
      callback: function($$v) {
        _vm.settings.getEmailNotifications = $$v
      },
      expression: "settings.getEmailNotifications"
    }
  })], 1)])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Change Password")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Notifications")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75f2c866!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings.vue
// module id = 2054
// module chunks = 2